import { render, staticRenderFns } from "./TabTransferencia.vue?vue&type=template&id=700ff778&scoped=true&"
import script from "./TabTransferencia.vue?vue&type=script&lang=js&"
export * from "./TabTransferencia.vue?vue&type=script&lang=js&"
import style0 from "./TabTransferencia.vue?vue&type=style&index=0&id=700ff778&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700ff778",
  null
  
)

export default component.exports